<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
<div class="dashboard-container">
<app-admin-nav></app-admin-nav>

<div id="dashboard">
    <span class="header">{{ 'orders_title' | translate }}</span>

    <div class="filters">
        <div class="filter-item">
            <ng-select [items]="statusFilterOptions" bindLabel="status"
                [placeholder]="'orders_filter_status_placeholder' | translate" class="fyes-select p-0" [searchable]="false" [clearable]="false"
                [(ngModel)]="selectedStatus" (change)="filterOrders()">
            </ng-select>
        </div>
        <div class="filter-item">
            <mat-form-field class="custom-date-field cursor-pointer" (click)="fromPicker.open()">
                <input class="cursor-pointer" matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate"
                    [placeholder]="'orders_filter_from_date' | translate" (dateChange)="filterOrders()" readonly />
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="filter-item">
            <mat-form-field class="custom-date-field cursor-pointer" (click)="toPicker.open()">
                <input class="cursor-pointer" matInput [matDatepicker]="toPicker" [(ngModel)]="toDate"
                    [placeholder]="'orders_filter_to_date' | translate" (dateChange)="filterOrders()" readonly />
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="filter-item">
            <div class="search-bar">
                <i class="fa-light fa-magnifying-glass me-2"></i>
                <input type="text" [placeholder]="'orders_search_placeholder' | translate" (ngModelChange)="onSearchChange($event)"
                    [(ngModel)]="searchTerm" />
            </div>
        </div>
    </div>

    <!-- Only the first load. Filtering and searching refetch through
         filterOrders(), and swapping the table for a spinner on every
         keystroke would be worse than the wait it is covering. -->
    @if (loadingOrders) {
        <div class="loading-state">
            <span class="spinner" role="status" [attr.aria-label]="'admin_loading' | translate"></span>
        </div>
    } @else {
        <div class="orders">
            <table mat-table [dataSource]="orders" class="custom-table">

                <!-- Order ID -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_order_no' | translate }} </th>
                    <td mat-cell *matCellDef="let order"> #{{ order.orderNo }} </td>
                </ng-container>

                <!-- Client Email -->
                <ng-container matColumnDef="clientEmail">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_client_email' | translate }} </th>
                    <td mat-cell *matCellDef="let order"> {{ order.contactDetails.email }} </td>
                </ng-container>

                <!-- Date -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_date' | translate }} </th>
                    <td mat-cell *matCellDef="let order"> {{ order.createdAt | customDate }} </td>
                </ng-container>

                <!-- Amount -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_amount' | translate }} </th>
                    <td mat-cell *matCellDef="let order"> €{{ order.totalPrice }} </td>
                </ng-container>

                <!-- Status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_status' | translate }} </th>
                    <td mat-cell *matCellDef="let order">
                        <span class="status" [ngClass]="order.status.toLowerCase()">
                            <span class="dot"></span> {{ order.status }}
                        </span>
                    </td>
                </ng-container>

                <!-- Assigned -->
                <ng-container matColumnDef="assignedTo">
                    <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_assigned_to' | translate }} </th>
                    <td mat-cell *matCellDef="let order">
                        @if (!order.assignedTo) { <button class="primary-btn" (click)="takeOrder(order)">{{ 'orders_action_take' | translate }}</button>}
                        @if (order.assignedTo) { <span >{{ order.assignedTo }}</span>}
                    </td>
                </ng-container>

                <!-- Menu -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let order">
                        <i class="fa-solid fa-eye cursor-pointer" style="color: #96A6B7;" (click)="viewOrder(order)"></i>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
        </div>
    }
</div>
</div>
</div>

<app-footer></app-footer>